import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from "react-router-dom";

// Firebase
import { db } from "./firebase";
import { doc, onSnapshot } from "firebase/firestore";

// Context
import { AuthContext } from "./context/auth.context";
import { useContext } from "react";

// Estilos
import './App.css';

// Componentes
import Navbar from "./components/Nav/Navbar";
import CookieBanner from "./components/CookieBanner";
import Footer from "./components/Footer/Footer";
import Reproductor from "./components/Reproductor";
import BotonDirecto from "./components/BotonDirecto";

// Páginas
import Login from "./pages/Login";
import ElReto from "./pages/ElReto";
import Colaboradores from "./pages/Colaboradores";
import Colabora from "./pages/Colabora";
import RetosAnteriores from "./pages/RetosAnteriores";
import ConoceACarmen from "./pages/ConoceACarmen";
import RutasEnBicicleta from "./pages/RutasEnBicicleta";
import Admin from "./pages/Admin";
import Gregarios from "./pages/Gregarios";
import RutaBicicletaDetalle from "./pages/RutaBicicletaDetalle";
import Contacto from "./pages/Contacto";
import HomeTest from "./pages/HomeTest";
import PageColaboradores from "./pages/PageColaboradores";
import Motivos from "./pages/Motivos";
import SigueElReto from "./pages/SigueElReto";
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [elRetoHaComenzado, setElRetoHaComenzado] = useState(false);
  const location = useLocation();

  // 1. Escuchar el estado del reto en Firebase en tiempo real
  useEffect(() => {
    const unsub = onSnapshot(doc(db, "configuracion", "reto"), (docSnap) => {
      if (docSnap.exists()) {
        setElRetoHaComenzado(docSnap.data().directoActivo);
      } else {
        console.warn("No se encontró el documento de configuración en Firebase.");
      }
    });

    return () => unsub(); // Limpiar suscripción al desmontar
  }, []);

  // 2. Lógica de visibilidad del botón:
  // Se muestra si el reto está activo en la DB Y NO estamos en la página del mapa
  const mostrarBotonDirecto = elRetoHaComenzado && location.pathname !== '/sigue-el-reto';

  return (
    <div className="app">
    <ScrollToTop/>
      <Navbar />
      
      {/* Componentes Globales con lógica condicional */}
      <Reproductor />
      
      {mostrarBotonDirecto && <BotonDirecto activo={true} />}
      
      <CookieBanner />

      <Routes>
        <Route path='/login' element= {<Login/>}/>
        <Route path='/admin' element= {<Admin/>}/>
        <Route path='/' element={<HomeTest />} />
        <Route path='/el-reto' element={<ElReto/>} />
        <Route path='/colaboradores' element={<PageColaboradores />} />
        <Route path='/colabora' element={<Colabora />} />
        <Route path='/retos-anteriores' element={<RetosAnteriores />} />
        <Route path='/conoce-a-carmen' element={<ConoceACarmen />} />
        <Route path='/rutas-bicicletas' element={<RutasEnBicicleta />} />
        <Route path='/ruta/:rutaId' element={<RutaBicicletaDetalle />} />
        <Route path='/contacto' element={<Contacto />} />
        <Route path='/motivos-para-pedalear' element={<Motivos/>} />
        <Route path='/sigue-el-reto' element={<SigueElReto/>} />
        
        {/* Ruta para Gregarios si decides activarla */}
        {/* <Route path='/gregarios' element={<Gregarios />} /> */}
      </Routes>

      <Footer />
    </div>
  );
}

export default App;